/**
 * Konbini Icon Data
 * Icon URL for Konbini payment method (Japan convenience store payments)
 */
export const KONBINI_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/2k2M0v6xdd5HvUNxX2sYCi/c9de881648bdd61adb15ec1941f2d47e/konbini_420x280.png';
